<template>
  <div id="products-panel" style="height: 100vh">
    <div class="search-bar">
      <input type="text" name="searchProducts" id="searchProducts" class="form-control-sm search-field"
             placeholder="Search by plu, barcode or name" @keyup.enter="searchProducts" @keyup="searchProducts"
             v-model="input">
    </div>
    <div class="product-grid" style="height: 95vh" ref="productsGrid" v-on:scroll="handleScroll">
      <DesktopProductItem v-for="item in stockProducts" :key="`product-` + item.PLU" :product="item"
                   @click="addToSale(item)" />
    </div>
    <div class="d-flex flex-row justify-content-between" >
      <div :class="`salesbtn ${isScrollable?`w-75`:`w-100`}`">
        <div class="cart-actions d-flex" style="gap: 5px">
          <button class="btn btn-secondary flex-fill" :disabled="disabled" :style="delivery"  @click="viewOpenTable">
            LOAD
          </button>
          <button class="btn btn-secondary flex-fill" :disabled="disabled" :style="saveColor" @click="saveTable">
            SAVE
          </button>
          <button class="btn btn-dark flex-fill" :disabled="disabled" :style="delivery" @click="processDelivery">
            DELIVERY
          </button>
          <button class="btn btn-primary flex-fill" :disabled="disabled" :style="color" @click="process">
            PAY
          </button>
        </div>
      </div>
    </div>

    <div class="scroll-controls" v-if="isScrollable">
      <button class="scroll-control" @click="scrollToTop">
        <font-awesome-icon :icon="['fas', 'chevron-up']" />
      </button>
      <button class="scroll-control" @click="scrollToBottom">
        <font-awesome-icon :icon="['fas', 'chevron-down']" />
      </button>
    </div>

  </div>
</template>
<script>
import DesktopProductItem from "@/components/point-of-sale/sales/pos/DesktopProductItem.vue";
import StockSearchBar from "@/components/point-of-sale/stock-search/StockSearchBar.vue";
import ProductItem from "@/components/point-of-sale/sales/pos/ProductItem.vue";
import ShoppingCart from "@/components/point-of-sale/sales/pos/ShoppingCart.vue";
import SaleDetails from "@/components/point-of-sale/sales/SaleDetails.vue";

export default {
  name: 'SearchedProducts',
  components: {SaleDetails, ShoppingCart, ProductItem, StockSearchBar,DesktopProductItem },
  computed: {
    curUser() {
      return this.$store.getters.getCurrentUser
    },
    showSearchBar() {
      return this.$store.getters.getShowSearchBar;
    },
    itemsInCart() {
      return this.$store.getters.getSaleLines.length
    },
    stockProducts() {
      return this.$store.getters.getStockProducts(this.limit)
          .filter(item => item.archived === false)
          .sort((a, b) => a.Description.localeCompare(b.Description));
    },
    limit() {
      return this.$store.getters.getLimit;
    },
    categorySearch() {
      return this.$store.getters.getSearchCategories
    },
    currentSale() {
      return this.$store.getters.getCurrentSale
    },
    disabled() {
      return this.saleTotal <= 0;
    },
    color() {
      return this.disabled ? {background: 'grey'} : {background: '#9ccc65'}
    },

    delivery() {
      return this.disabled ? {background: 'grey'} : {background: '#37b1c6'}
    },

    saveColor() {
      return this.disabled ? {background: 'grey'} : {background: '#475f9b'}
    }
  },
  created() {
    // Load saved sale lines when component is created
    this.$store.dispatch("loadFromLocalStorage");
  },
  data() {
    return {
      input: '',
      timer: undefined,
      isScrollable: true,
      scrollPosition: 0,
      maxScrollTop: 0,
    }
  },
  methods: {
    saveTable() {
      let close = document.getElementById(`canvasClose`);
      if (close) close.click();
      if (!this.currentSale || this.currentSale === 0) {
        return this.createTable();
      }
      return this.editTable();
    },
    /**
     * Silent helper that persists the current sale lines to the open table record.
     * Mirrors the source app's updateTable() in `Restaurant POS - Lytning/SearchedProducts.vue`.
     * Does NOT show any UI/dialogs — callers are expected to provide their own user feedback.
     *
     * Dispatches `syncOpenTable` (NOT `AddOrUpdateTable`) so the sale lines,
     * customer, and LPO remain in state — `AddOrUpdateTable` would commit
     * `clearSale` and wipe them before the user reaches the payment screen.
     *
     * SaleNum falls back to the route query (`saleNumber`) when state was reset unexpectedly,
     * matching the recovery behaviour of `saveTable()`.
     *
     * @returns {Promise} Resolves when the syncOpenTable dispatch completes.
     */
    updateTable() {
      let table = {};
      const routeSaleNumber = Number(this.$route?.query?.saleNumber || 0);
      table.items = this.$store.getters.getSaleLines;
      table.Customer = this.$store.getters.getCustomer;
      table.name = this.$store.getters.getOpenTableName;
      table.SaleNum = Number(this.currentSale || routeSaleNumber || 0);
      return this.$store.dispatch('syncOpenTable', table);
    },
    loadPanel() {
      return Swal.fire({
        html: 'Updating table....',
        allowOutsideClick: false,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading()
        },
      });
    },
    editTable() {
      let settings = this.$store.getters.getDeviceSettings;
      let table = {};
      this.loadPanel()
      table.items = this.$store.getters.getSaleLines;
      table.Customer = this.$store.getters.getCustomer;
      table.name = this.$store.getters.getOpenTableName;
      return this.$store.dispatch('updateTable', table)
          .then(() => {
            responses.showInfo('Table successfully updated')
            let autoLogout = settings.AutoLog === 1;
            if (autoLogout) {
              return this.$router.push({name: `poslogin`});
            }
            return this.$router.push({name: `tables`})
          }).finally(() => {
            this.$store.dispatch("clearLocalStorage")
            Swal.close()
          })
    },
    createTable() {
      this.$store.commit('setIsTabOpen', true)
      return Swal.fire({
        title: 'Table Name',
        icon: 'question',
        input: 'text',
        showCancelButton: true,
        confirmButtonText: 'Save Table',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: (input) => {
          if (!input) return Swal.showValidationMessage(`Table name is required`);
          this.$store.commit(`setOpenTableName`, input)
          return this.$store.dispatch('saveNewTable', {
            name: input,
            Customer: this.$store.getters.getCustomer,
          }).then(() => input)
              .catch(error => Swal.showValidationMessage(error))
        },
      }).then((result) => {
        this.$store.commit('setIsTabOpen', false)
        if (result.isConfirmed) {
          return Swal.fire({
            title: `Success`,
            icon: 'success',
            text: `Table ${result.value} Saved`
          }).then(() => {
            this.$store.dispatch("clearLocalStorage")
            this.$store.dispatch(`proceedToSales`)
            if (this.$route.path !== '/tables'){
              if(this.curUser.Username){
                this.$router.push({name: `tables`})
              }
            }
          })
        }
      })
    },
    /**
     * PAY button handler. If an open table is currently in state, any newly
     * added items are persisted to that table record via `updateTable()`
     * BEFORE navigating to the payment screen, so the open table reflects the
     * latest sale when the cashier returns to it later.
     *
     * Mirrors the source app's behaviour in `Restaurant POS - Lytning/SearchedProducts.vue`.
     * `processDelivery()` inherits this auto-sync because it delegates here.
     *
     * @returns {Promise} Resolves once navigation to the payment screen has been triggered.
     */
    async process() {
      // Update table if there's an open table with new items
      const openTableName = this.$store.getters.getOpenTableName;
      if (openTableName) {
        await this.updateTable();
      }
      return this.$router.push({name: 'payment'})
    },
    processDelivery() {
      this.$store.commit(`setTipAmount`, 0)
      return this.process();
    },
    searchProducts() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.$utils.hideLoading()
      }
      this.timer = setTimeout(() => {
        this.$utils.showLoading()
        let cat = this.categorySearch

        const query = {
          description: this.input,
          category: cat.category || '',
          subCategory: cat.subCategory || '',
          sub2Category: cat.sub2Category || ''
        }
        return this.$store.dispatch('searchDescription', query)
            .finally(() => this.$utils.hideLoading())
      }, 300)
    },
    viewOpenTable() {
        return this.$router.push({ name: 'tables' })
    },
    viewShoppingCart() {
    },
    addToSale(item) {
      return this.$store.dispatch('getStockSetting', item.PLU)
          .then(async (set) => {
            let cost = Number(item.InclCost.toFixed(2));
            let price = Number(item.SellingIncl.toFixed(2));
            let description = item.Description;

            let quantity = 1;
            if (set.getQtyFromPrice) {
              const { value: totalItemPrice } = await Swal.fire({
                title: 'Enter Total Item Price',
                input: 'number',
                icon : "question",
                inputLabel: 'Total Item Price',
                inputPlaceholder: 'Enter the total price for the items',
                showCancelButton: true,
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                inputValidator: (value) => {
                  if (!value || isNaN(value) || value <= 0) {
                    return 'Please enter a valid price!';
                  }
                }
              });

              if (totalItemPrice) {
                quantity = totalItemPrice / price;
              }
            }

            if (cost > price) {
              const result = await Swal.fire({
                allowOutsideClick: false,
                icon: "warning",
                showCancelButton: true,
                showLoaderOnConfirm: true,
                title: `Cost price is greater than Selling price`,
                confirmButtonText: 'Proceed',
                focusConfirm: false,
              });

              if (!result.isConfirmed) {
                return;
              }
            }

            if (set.askForDescription || set.askForBoth) {
              description = (await this.askForDescription(item));
            }

            if (set.askForPrice || set.askForBoth) {
              price = (await this.askForPrice(item));
            }

            let tourismLevy = 0.0;
            if (set.tourism){
              let obj = { amount : price, incl : true }
              tourismLevy = await this.$store.dispatch('getTourismLevyAmount', obj);
            }

            if (set.cookingLink) {
              return this.$router.push({
                name: 'instruction',
                query: { 
                  plu: item.PLU, 
                  saleNumber: this.$route.query.saleNumber,
                  cookingLink: set.cookingLink 
                }
              });
            }
            let specialPrice = this.$store.getters.getItemSpecialPrice(item.PLU)
            if (specialPrice) {
              responses.showSuccess(`Special Detected`)
              price = specialPrice;
            }
            let obj = {
              Plu: item.PLU,
              Description: description,
              Qty: quantity,
              Unit: price,
              Line: price,
              tourismLevy,
              Discount: 0,
              vat: 0,
              instructions: []
            }
            this.$store.commit('addToCurrentSaleLines', obj);
            return this.$store.dispatch(`calculateTipAmount`)
          })
    },
    askForPrice(item) {
      this.$store.commit('setIsTabOpen', true)
      return Swal.fire({
        allowOutsideClick: false,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        title: `Set Selling Price`,
        html: `<h6 >Description : ${item.Description}</h6>
               <h6 >Current Price : ${$utils.formatMoney(item.SellingIncl)}</h6>
               <input type="number" step="0.01" id="selling-prc" class="swal2-input" placeholder="Selling Price" style="max-width: 70%">`,
        confirmButtonText: 'Set Price',
        focusConfirm: false,
        preConfirm: async () => {
          let value = Swal.getPopup().querySelector('#selling-prc').value;
          if (!value) {
            Swal.showValidationMessage(`Please enter a valid Selling Price`)
          }
          return parseFloat(value);
        }
      }).then(result => {
        this.$store.commit('setIsTabOpen', false)
        if (result.isConfirmed) {
          return result.value;
        }
        return parseFloat(item.SellingIncl.toFixed(2))
      })
    },
    askForDescription(item) {
      this.$store.commit('setIsTabOpen', true)
      return Swal.fire({
        allowOutsideClick: false,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        title: `Set Description`,
        html: `<h6 >Description : ${item.Description}</h6>
               <textarea id="desc-ask" class="swal2-input" placeholder="Description" style="max-width: 70%">`,
        confirmButtonText: 'Set Description',
        focusConfirm: false,
        preConfirm: async () => {
          let value = Swal.getPopup().querySelector('#desc-ask').value
          if (!value || value.toString().trim() === "") {
            Swal.showValidationMessage(`Please enter a valid Description`)
          }
          return value;
        }
      }).then(result => {
        this.$store.commit('setIsTabOpen', false)
        if (result.isConfirmed) {
          return result.value;
        }
        return item.Description
      })
    },
    scrollToTop() {
      const newScrollTop = Math.max(this.scrollPosition - 110, 0);
      this.$refs.productsGrid.scrollTo({
        top: newScrollTop,
        behavior: 'smooth',
      });
    },
    async scrollToBottom() {
      await this.$store.commit(`setLimit`, this.limit + 4);
      const newScrollTop = Math.min(this.scrollPosition + 110, this.maxScrollTop);
      this.$refs.productsGrid.scrollTo({
        top: newScrollTop,
        behavior: 'smooth',
      });
    },
    handleScroll() {
      const scroll = {
        scrollTop: this.$refs.productsGrid.scrollTop,
        scrollHeight: this.$refs.productsGrid.scrollHeight,
        clientHeight: this.$refs.productsGrid.clientHeight
      }
      this.scrollPosition = scroll.scrollTop
      this.maxScrollTop = scroll.scrollHeight - scroll.clientHeight
      this.isScrollable = scroll.scrollHeight > scroll.clientHeight;
    },
  }
}
</script>

<style lang="scss" scoped>
.offcanvas {
  padding: 0;

  .offcanvas-body {
    padding: 0 !important;
    position: relative;
  }
}

#products-panel {
  padding: 2px 5px 0 5px;
  display: flex;
  flex-direction: column;
  //border-left: 1px solid #eee;
  position: relative;

  .scroll-controls {
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .scroll-control {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: rgba(59, 130, 246, 0.2);
      color: #3b82f6;
    }
  }

  .search-bar {
    display: flex;
    flex-direction: row;
    gap: 8px;

    .search-field {
      width: 100%;
    }

    .view-cart-btn {
      background: #0092f7;
      color: white;
      border-radius: 5px;

      .cart-count {
        position: absolute;
        top: -10px;
        right: -10px;
        color: white;
        background: coral;
      }
    }
  }

  .product-grid {
    overflow-y: auto;
    overflow-x: hidden;
    display: grid;
    gap: 1.8em 0.6em; /* First value is row gap, second is column gap */
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    grid-auto-rows: 100px; /* Uniform row heights */
    padding: 5px;
  }
}
.sales-stats {
  flex: 0 1 auto;
  height: 85px;
  border-top: 1px solid #eee;
  padding-top: 5px;
  position: absolute !important;
  bottom: 5px !important;

  .cart-actions {
    .btn {
      border-radius: 0;
      color: #ffffff;
      font-weight: 600;
      border: none;

      &.btn-primary {
        background: #3496F0;
      }

      &.btn-secondary {
        background: #C6C6C6;
        //color: #585858;
      }

      &.btn-dark {
        background: #2D2D2D;
      }
    }
  }
}
.salesbtn{
  //border-top: 1px solid #eee;
  //padding-top: 5px;
  position: absolute !important;
  bottom: 5px !important;
}
</style>